import RoleRestService from '../rest/RoleRestService'
import PermissionService from './PermissionService'
import { TFunction } from 'i18next'

class RoleService {
  get() {
    return RoleRestService.get()
  }

  async getRoles(setRoles: Function) {
    const roles = await RoleRestService.get()
    setRoles(roles)
  }

  async createRole(role: any, setRoles: Function, t: TFunction) {
    try {
      const editedRole = await RoleRestService.create(role)
      const roles = await RoleRestService.get()
      setRoles(roles)
      return t('role.createSuccess', { name: editedRole.name })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateRole(role: any, setRoles: Function, t: TFunction) {
    try {
      const editedRole = await RoleRestService.update(role)
      const roles = await RoleRestService.get()
      setRoles(roles)
      return t('role.editSuccess', { name: editedRole.name })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async deleteRole(role: any, setRoles: Function, t: TFunction) {
    try {
      await RoleRestService.delete(role.id)
      const roles = await RoleRestService.get()
      setRoles(roles)
      return t('role.deleteSuccess', { name: role.name })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  getAssignedPermissions(id: number) {
    return RoleRestService.getAssignedPermissions(id)
  }

  async assignPermissions(permissions: any[], roleId: number, roleName: string, t: TFunction) {
    await RoleRestService.updateAssignedPermissions(
      roleId,
      permissions.filter((permission) => permission.isAssigned).map((permission) => permission.id)
    )
    return t('role.assignPermissionsSuccess', { name: roleName })
  }

  async getPermissionsWithAssigned(id: number) {
    const allPermissions: any[] = await PermissionService.get()
    const rolePermissions: any[] = await RoleRestService.getAssignedPermissions(id)

    const rolePermissionIds: number[] = rolePermissions.map((permission: { id: any }) => permission.id)
    allPermissions.forEach((permission) => {
      if (rolePermissionIds.includes(permission.id)) {
        permission.isAssigned = true
      } else {
        permission.isAssigned = false
      }
    })
    return allPermissions
  }
}

export default new RoleService()
